class PreAuthorizeNotify {
  static getEmailData = (dst, user) => {
    const from = `Gobierno de El Salvador <info@goes.gob.sv>`;

    const to = dst;
    const subject = `Haz sido pre-autorizado para acceder al Portal`;
    const body = templeteData(user);

    return {
      from,
      to,
      subject,
      body
    };
  };
}

export default PreAuthorizeNotify;

const templeteData = (user) => {
  return `
        <h2 style="text-align: center;">
        Solicitud pre-autorizada - Portal de Proyectos Gobierno de El Salvador
        </h2>
        <br />
        <p>Estimado(a) ${user?.displayName}</p>
        <br />
        <p>
        Queremos informarte que tu solicitud de registro ha sido pre-autorizada para el acceso al portal de proyectos del Gobierno de El Salvador.
        </p>
        <p>
            Completa el proceso de registro ingresando al portar <a href="${'https://portal.modernizacion.gob.sv'}">aquí</a>,
            descarga y diligencia debidamente los formularios de NOMBRAMIENTO DEL REPRESENTANTE INSTITUCIONAL y ACUERDO DE AFILIACIÓN INDIVIDUALIZADO,
            cárgalos al Portal, sigues los pasos que allí te muestran.
        </p>
        <br />
        <br />
        <p>Saludos,</p>
        <br />
        <p>Portal de Proyectos Gobierno de El Salvador en Convenio con Google LLC</p>`;
};
